function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
  fill: "#E84142"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9832 14.2041C18.3744 13.4925 19.0057 13.4925 19.3969 14.2041L21.833 18.7079C22.2242 19.4195 21.9042 20 21.1217 20H16.2139C15.4404 20 15.1203 19.4195 15.5026 18.7079L17.9832 14.2041ZM13.2709 5.53371C13.6621 4.8221 14.2845 4.8221 14.6757 5.53371L15.2181 6.56367L16.4984 8.93258C16.8096 9.60674 16.8096 10.4026 16.4984 11.0768L12.204 18.9139C11.8128 19.5506 11.1637 19.9532 10.4436 20H6.87825C6.09584 20 5.77576 19.4288 6.16696 18.7079L13.2709 5.53371Z",
  fill: "white"
});
function SvgTokenAvax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenAvax);
export default __webpack_public_path__ + "static/media/token-avax.245c3c216e812da65179cef887e79f04.svg";
export { ForwardRef as ReactComponent };